export default __webpack_public_path__ + "static/media/salevali.45b1b1ca.png";